/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HotelPropertyContentImage
 */
export interface HotelPropertyContentImage {
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentImage
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentImage
     */
    caption?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentImage
     */
    category?: string;
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentImage
     */
    roomId?: number;
}

/**
 * Check if a given object implements the HotelPropertyContentImage interface.
 */
export function instanceOfHotelPropertyContentImage(value: object): value is HotelPropertyContentImage {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function HotelPropertyContentImageFromJSON(json: any): HotelPropertyContentImage {
    return HotelPropertyContentImageFromJSONTyped(json, false);
}

export function HotelPropertyContentImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelPropertyContentImage {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'caption': json['caption'] == null ? undefined : json['caption'],
        'category': json['category'] == null ? undefined : json['category'],
        'roomId': json['room_id'] == null ? undefined : json['room_id'],
    };
}

export function HotelPropertyContentImageToJSON(json: any): HotelPropertyContentImage {
    return HotelPropertyContentImageToJSONTyped(json, false);
}

export function HotelPropertyContentImageToJSONTyped(value?: HotelPropertyContentImage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'caption': value['caption'],
        'category': value['category'],
        'room_id': value['roomId'],
    };
}

